// import React, { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import { encryptPayload, decryptResponse } from "./../CryptoUtil";

// // PHP backend runs on Apache, not React port 3000.
// const base = "http://localhost/retailer_api/";
// const norm = (value) => String(value ?? "").trim().toUpperCase();
// const nameOf = (item) => item?.name || item?.full_name || "";

// function headers() {
//   let session = {};
//   try { session = JSON.parse(localStorage.getItem("userSession") || "{}"); } catch (_) {}
//   return {
//     Accept: "application/json",
//     ...(session?.token ? { Authorization: `Bearer ${session.token}` } : {}),
//   };
// }

// function decode(raw) {
//   if (raw?.encrypted?.payload !== undefined) {
//     return decryptResponse(raw.encrypted.payload, raw.encrypted.transactionId);
//   }
//   if (raw?.payload !== undefined && raw?.transactionId) {
//     return decryptResponse(raw.payload, raw.transactionId);
//   }
//   return raw;
// }

// function errorText(error) {
//   try { return decode(error.response?.data)?.message || error.message; }
//   catch (_) { return error.message || "Request failed"; }
// }

// function areaText(item) {
//   const raw = item?.working_area_new ?? item?.working_area;
//   if (!raw) return "Not configured";
//   let area = raw;
//   if (typeof area === "string") {
//     try { area = JSON.parse(area); } catch (_) { return area; }
//   }
//   if (!area || typeof area !== "object") return "Not configured";
//   return Object.entries(area).map(([state, districts]) => {
//     if (Array.isArray(districts)) return `${state}: ${districts.map(d => typeof d === "string" ? d : d.district || d.name || "").join(", ")}`;
//     if (districts && typeof districts === "object") return `${state}: ${Object.keys(districts).join(", ")}`;
//     return state;
//   }).join(" | ");
// }

// export default function AsmTransfer() {
//   const [asms, setAsms] = useState([]);
//   const [zsms, setZsms] = useState([]);
//   const [eligibleZsms, setEligibleZsms] = useState([]);
//   const [query, setQuery] = useState("");
//   const [selectedAsm, setSelectedAsm] = useState(null);
//   const [chosenZsm, setChosenZsm] = useState("");
//   const [zsmQuery, setZsmQuery] = useState("");
//   const [modalOpen, setModalOpen] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [loadingZsms, setLoadingZsms] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState("");
//   const [message, setMessage] = useState("");

//   async function loadAsms() {
//     const response = await axios.get(`${base}getAsmTransfer.php`, {
//       withCredentials: true, headers: headers(), timeout: 20000,
//     });
//     const result = decode(response.data);
//     if (!result?.success) throw new Error(result?.message || "Unable to load ASMs");
//     setAsms(result.asms || []);
//     setZsms(result.zsms || []);
//   }

//   useEffect(() => {
//     let active = true;
//     async function start() {
//       try {
//         await loadAsms();
//       } catch (err) {
//         if (active) setError(errorText(err));
//       } finally {
//         if (active) setLoading(false);
//       }
//     }
//     start();
//     return () => { active = false; };
//   }, []);

//   const zsmNames = useMemo(() => new Map(zsms.map(z => [norm(z.id), nameOf(z)])), [zsms]);
//   const filtered = asms.filter(asm => {
//     if (!query.trim()) return false;
//     const text = [asm.id, nameOf(asm), asm.phone, asm.mobile, asm.zsm_id, areaText(asm)].join(" ");
//     return norm(text).includes(norm(query));
//   });
//   const filteredZsms = eligibleZsms.filter(z => [z.id, nameOf(z), areaText(z)]
//     .some(value => norm(value).includes(norm(zsmQuery))));

//   async function openTransfer(asm) {
//     setSelectedAsm(asm);
//     setChosenZsm("");
//     setZsmQuery("");
//     setError("");
//     setModalOpen(true);
//     setLoadingZsms(true);
//     setEligibleZsms([]);
//     try {
//       const response = await axios.post(`${base}getTransferZsms.php`,
//         encryptPayload({ asm_id: asm.id }), {
//           withCredentials: true,
//           headers: { ...headers(), "Content-Type": "application/json" },
//           timeout: 20000,
//         });
//       const result = decode(response.data);
//       if (!result?.success) throw new Error(result?.message || "Unable to load matching ZSMs");
//       setEligibleZsms(result.zsms || []);
//     } catch (err) {
//       setError(errorText(err));
//     } finally {
//       setLoadingZsms(false);
//     }
//   }

//   async function confirmTransfer() {
//     if (!selectedAsm || !chosenZsm || saving) return;
//     setSaving(true);
//     setError("");
//     try {
//       const response = await axios.post(`${base}transferAsm.php`,
//         encryptPayload({ asm_id: selectedAsm.id, zsm_id: chosenZsm }), {
//           withCredentials: true,
//           headers: { ...headers(), "Content-Type": "application/json" },
//           timeout: 20000,
//         });
//       const result = decode(response.data);
//       if (!result?.success) throw new Error(result?.message || "Transfer failed");
//       setMessage(result.message || "ASM transferred successfully");
//       setModalOpen(false);
//       await loadAsms();
//     } catch (err) {
//       setError(errorText(err));
//     } finally {
//       setSaving(false);
//     }
//   }

//   return (
//     <div className="container-fluid py-4">
//       <h2 className="fw-bold mb-1">ASM Transfer</h2>
//       <p className="text-secondary mb-4">Search ASM by district or city, then transfer one ASM to a matching ZSM.</p>
//       {error && <div className="alert alert-danger">{error}</div>}
//       {message && <div className="alert alert-success">{message}</div>}
//       <div className="card rounded-4 border mb-4"><div className="card-body p-4">
//         <label className="form-label fw-semibold" htmlFor="asm-search">Search ASM</label>
//         <input id="asm-search" className="form-control" value={query}
//           onChange={e => setQuery(e.target.value)}
//           placeholder="Search district, state, ASM ID, name or phone" />
//       </div></div>
//       <div className="card rounded-4 border"><div className="card-body p-3 p-md-4">
//         <h5 className="fw-bold mb-3">ASM List {query.trim() ? `(${filtered.length})` : ""}</h5>
//         <div className="table-responsive"><table className="table table-hover align-middle">
//           <thead className="table-light"><tr>
//             <th>ASM ID</th><th>ASM Name</th><th>Phone</th><th>Current ZSM</th><th>Working Area</th><th>Action</th>
//           </tr></thead>
//           <tbody>
//             {filtered.map(asm => <tr key={asm.id}>
//               <td>{asm.id}</td><td>{nameOf(asm) || "—"}</td>
//               <td>{asm.phone || asm.mobile || "—"}</td>
//               <td><div className="fw-semibold">{zsmNames.get(norm(asm.zsm_id)) || asm.zsm_name || "Unknown ZSM"}</div>
//                 <small className="text-secondary">{asm.zsm_id || "Not assigned"}</small></td>
//               <td style={{ minWidth: 220 }}>{areaText(asm)}</td>
//               <td><button type="button" className="btn btn-sm btn-outline-primary"
//                 onClick={() => openTransfer(asm)}>Transfer</button></td>
//             </tr>)}
//             {loading && <tr><td colSpan="6" className="text-center py-4">Loading ASMs...</td></tr>}
//             {!loading && !query.trim() && <tr><td colSpan="6" className="text-center text-secondary py-4">Search district, city or ASM to see results.</td></tr>}
//             {!loading && query.trim() && !filtered.length && <tr><td colSpan="6" className="text-center text-secondary py-4">No matching ASM found.</td></tr>}
//           </tbody>
//         </table></div>
//       </div></div>
//       {modalOpen && <div className="modal d-block" role="dialog" aria-modal="true"
//         aria-label="Transfer ASM" style={{ background: "rgba(0,0,0,.55)" }}>
//         <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
//           <div className="modal-content rounded-4">
//             <div className="modal-header"><h5 className="modal-title fw-bold">Transfer {selectedAsm?.id} to ZSM</h5>
//               <button type="button" className="btn-close" aria-label="Close" disabled={saving}
//                 onClick={() => setModalOpen(false)} /></div>
//             <div className="modal-body">
//               <p className="text-secondary small">Only ZSMs covering this ASM's working districts/cities are listed. Default ZSM is also available.</p>
//               <input className="form-control mb-3" value={zsmQuery}
//                 onChange={e => setZsmQuery(e.target.value)} placeholder="Search ZSM by ID, name or district" />
//               <div className="table-responsive"><table className="table table-hover align-middle">
//                 <thead className="table-light"><tr><th>Select</th><th>ZSM ID</th><th>ZSM Name</th><th>Working Area</th></tr></thead>
//                 <tbody>
//                   {filteredZsms.map(zsm => <tr key={zsm.id} onClick={() => setChosenZsm(zsm.id)} style={{ cursor: "pointer" }}>
//                     <td><input type="radio" name="destinationZsm" className="form-check-input"
//                       checked={chosenZsm === zsm.id} onChange={() => setChosenZsm(zsm.id)} /></td>
//                     <td>{zsm.id}</td><td>{nameOf(zsm)}</td><td>{areaText(zsm)}</td>
//                   </tr>)}
//                   {loadingZsms && <tr><td colSpan="4" className="text-center py-4">Loading matching ZSMs...</td></tr>}
//                   {!loadingZsms && !filteredZsms.length && <tr><td colSpan="4" className="text-center py-4">No ZSM covers this ASM's working districts.</td></tr>}
//                 </tbody>
//               </table></div>
//             </div>
//             <div className="modal-footer">
//               <button type="button" className="btn btn-light" disabled={saving} onClick={() => setModalOpen(false)}>Cancel</button>
//               <button type="button" className="btn btn-primary" disabled={!chosenZsm || saving || loadingZsms}
//                 onClick={confirmTransfer}>{saving ? "Transferring..." : "Confirm Transfer"}</button>
//             </div>
//           </div>
//         </div>
//       </div>}
//     </div>
//   );
// }



import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { encryptPayload, decryptResponse } from "./../CryptoUtil";

const API = "http://localhost/retailer_api/";

const normalize = (value) =>
  String(value ?? "").trim().toUpperCase();

const getName = (item) =>
  item?.name || item?.full_name || "";

function getHeaders() {
  let session = {};

  try {
    session = JSON.parse(
      localStorage.getItem("userSession") || "{}"
    );
  } catch (error) {
    session = {};
  }

  return {
    Accept: "application/json",
    ...(session?.token
      ? { Authorization: `Bearer ${session.token}` }
      : {}),
  };
}

function decode(raw) {
  if (raw?.encrypted?.payload !== undefined) {
    return decryptResponse(
      raw.encrypted.payload,
      raw.encrypted.transactionId
    );
  }

  if (raw?.payload !== undefined && raw?.transactionId) {
    return decryptResponse(
      raw.payload,
      raw.transactionId
    );
  }

  return raw;
}

function getError(error) {
  try {
    return (
      decode(error.response?.data)?.message ||
      error.message ||
      "Request failed."
    );
  } catch {
    return error.message || "Request failed.";
  }
}

function getAreaText(item) {
  const raw =
    item?.working_area_new ??
    item?.working_area;

  if (!raw) return "Not configured";

  let area = raw;

  if (typeof area === "string") {
    try {
      area = JSON.parse(area);
    } catch {
      return area;
    }
  }

  if (Array.isArray(area)) {
    return area
      .map((item) => {
        if (typeof item === "string") return item;

        const state = item?.state || item?.name || "";
        const districts = item?.districts || [];

        return `${state}: ${
          Array.isArray(districts)
            ? districts.join(", ")
            : ""
        }`;
      })
      .join(" | ");
  }

  if (!area || typeof area !== "object") {
    return "Not configured";
  }

  return Object.entries(area)
    .map(([state, districts]) => {
      if (Array.isArray(districts)) {
        const names = districts.map((district) =>
          typeof district === "string"
            ? district
            : district?.district || district?.name || ""
        );

        return `${state}: ${names.join(", ")}`;
      }

      if (districts && typeof districts === "object") {
        return `${state}: ${Object.keys(districts).join(", ")}`;
      }

      return state;
    })
    .join(" | ");
}

export default function AsmTransfer() {
  const [asms, setAsms] = useState([]);
  const [zsms, setZsms] = useState([]);

  const [query, setQuery] = useState("");

  const [selectedAsm, setSelectedAsm] = useState(null);
  const [eligibleZsms, setEligibleZsms] = useState([]);

  const [chosenZsm, setChosenZsm] = useState("");
  const [zsmQuery, setZsmQuery] = useState("");

  const [modalOpen, setModalOpen] = useState(false);

  const [loading, setLoading] = useState(true);
  const [loadingZsms, setLoadingZsms] = useState(false);
  const [saving, setSaving] = useState(false);

  const [error, setError] = useState("");
  const [modalError, setModalError] = useState("");
  const [message, setMessage] = useState("");

  async function loadAsms() {
    const response = await axios.get(
      `${API}getAsmTransfer.php`,
      {
        withCredentials: true,
        headers: getHeaders(),
        timeout: 20000,
      }
    );

    const result = decode(response.data);

    if (result?.success === false) {
      throw new Error(
        result.message || "Unable to load ASM records."
      );
    }

    setAsms(result.asms || result.data?.asms || []);
    setZsms(result.zsms || result.data?.zsms || []);
  }

  useEffect(() => {
    let active = true;

    async function start() {
      try {
        await loadAsms();
      } catch (error) {
        if (active) {
          setError(getError(error));
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    start();

    return () => {
      active = false;
    };
  }, []);

  const zsmNames = useMemo(() => {
    return new Map(
      zsms.map((zsm) => [
        normalize(zsm.id),
        getName(zsm),
      ])
    );
  }, [zsms]);

  const filteredAsms = useMemo(() => {
    const search = normalize(query);

    if (!search) return [];

    return asms.filter((asm) => {
      const text = [
        asm.id,
        getName(asm),
        asm.phone,
        asm.mobile,
        asm.zsm_id,
        asm.zsm_name,
        getAreaText(asm),
      ].join(" ");

      return normalize(text).includes(search);
    });
  }, [asms, query]);

  const filteredZsms = useMemo(() => {
    const search = normalize(zsmQuery);

    return eligibleZsms.filter((zsm) => {
      const text = [
        zsm.id,
        getName(zsm),
        getAreaText(zsm),
      ].join(" ");

      return normalize(text).includes(search);
    });
  }, [eligibleZsms, zsmQuery]);

  const currentZsm = useMemo(() => {
    if (!selectedAsm) return null;

    return (
      zsms.find(
        (zsm) =>
          normalize(zsm.id) ===
          normalize(selectedAsm.zsm_id)
      ) || null
    );
  }, [zsms, selectedAsm]);

  async function openTransfer(asm) {
    setSelectedAsm(asm);
    setChosenZsm("");
    setZsmQuery("");
    setEligibleZsms([]);
    setModalError("");
    setError("");
    setMessage("");

    setModalOpen(true);
    setLoadingZsms(true);

    try {
      const response = await axios.post(
        `${API}asmTransfer.php`,
        encryptPayload({
          action: "eligible",
          asm_id: asm.id,
        }),
        {
          withCredentials: true,
          headers: {
            ...getHeaders(),
            "Content-Type": "application/json",
          },
          timeout: 20000,
        }
      );

      const result = decode(response.data);

      if (result?.success !== true) {
        throw new Error(
          result?.message || "Unable to load eligible ZSMs."
        );
      }

      setEligibleZsms(
        result.zsms || result.data?.zsms || []
      );
    } catch (error) {
      setModalError(getError(error));
    } finally {
      setLoadingZsms(false);
    }
  }

  function closeModal() {
    if (saving) return;

    setModalOpen(false);
    setSelectedAsm(null);
    setChosenZsm("");
    setModalError("");
    setEligibleZsms([]);
  }

  async function confirmTransfer() {
    if (!selectedAsm || !chosenZsm || saving) return;

    setSaving(true);
    setModalError("");

    try {
      const response = await axios.post(
        `${API}asmTransfer.php`,
        encryptPayload({
          action: "transfer",
          asm_id: selectedAsm.id,
          zsm_id: chosenZsm,
        }),
        {
          withCredentials: true,
          headers: {
            ...getHeaders(),
            "Content-Type": "application/json",
          },
          timeout: 20000,
        }
      );

      const result = decode(response.data);

      if (result?.success !== true) {
        throw new Error(
          result?.message || "ASM transfer failed."
        );
      }

      setModalOpen(false);
      setSelectedAsm(null);
      setChosenZsm("");
      setEligibleZsms([]);

      setMessage(
        result.message || "ASM transferred successfully."
      );

      await loadAsms();
    } catch (error) {
      setModalError(getError(error));
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="container-fluid py-4">
      <h4 className="mb-2">ASM Transfer</h4>

      <p className="text-muted mb-4">
        Search ASM and transfer to another eligible ZSM.
      </p>

      {error && (
        <div className="alert alert-danger">
          {error}
        </div>
      )}

      {message && (
        <div className="alert alert-success">
          {message}
        </div>
      )}

      <div className="card mb-4">
        <div className="card-body">
          <div className="form-group mb-0">
            <label htmlFor="asmSearch">
              Search ASM / State / District
            </label>

            <input
              id="asmSearch"
              type="search"
              className="form-control"
              placeholder="Example: Madhya Pradesh, Bhopal, ASM1005"
              value={query}
              onChange={(event) =>
                setQuery(event.target.value)
              }
            />
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="mb-3">
            ASM List
            {query.trim()
              ? ` (${filteredAsms.length})`
              : ""}
          </h5>

          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>ASM ID</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Current ZSM</th>
                  <th>Working Area</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {!loading &&
                  filteredAsms.map((asm) => (
                    <tr key={asm.id}>
                      <td>{asm.id}</td>

                      <td>
                        {getName(asm) || "—"}
                      </td>

                      <td>
                        {asm.phone || asm.mobile || "—"}
                      </td>

                      <td>
                        <strong>
                          {zsmNames.get(
                            normalize(asm.zsm_id)
                          ) ||
                            asm.zsm_name ||
                            "Unknown ZSM"}
                        </strong>

                        <div className="text-muted small">
                          {asm.zsm_id || "Not assigned"}
                        </div>
                      </td>

                      <td style={{ minWidth: 230 }}>
                        {getAreaText(asm)}
                      </td>

                      <td>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={() =>
                            openTransfer(asm)
                          }
                        >
                          Transfer
                        </button>
                      </td>
                    </tr>
                  ))}

                {loading && (
                  <tr>
                    <td
                      colSpan="6"
                      className="text-center py-4"
                    >
                      Loading ASM records...
                    </td>
                  </tr>
                )}

                {!loading && !query.trim() && (
                  <tr>
                    <td
                      colSpan="6"
                      className="text-center py-4 text-muted"
                    >
                      Search an ASM, state or district.
                    </td>
                  </tr>
                )}

                {!loading &&
                  query.trim() &&
                  filteredAsms.length === 0 && (
                    <tr>
                      <td
                        colSpan="6"
                        className="text-center py-4 text-muted"
                      >
                        No matching ASM found.
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {modalOpen && (
        <div
          className="modal d-block"
          role="dialog"
          aria-modal="true"
          aria-label="Transfer ASM"
          style={{
            background: "rgba(0,0,0,0.55)",
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Transfer ASM — {selectedAsm?.id}
                </h5>

                <button
                  type="button"
                  className="close"
                  onClick={closeModal}
                  disabled={saving}
                  aria-label="Close"
                >
                  <span aria-hidden="true">
                    ×
                  </span>
                </button>
              </div>

              <div className="modal-body">
                {modalError && (
                  <div className="alert alert-danger">
                    {modalError}
                  </div>
                )}

                <div className="alert alert-info">
                  <strong>
                    Current Reporting ZSM
                  </strong>

                  <div className="mt-2">
                    <strong>
                      {selectedAsm?.zsm_id ||
                        "Not assigned"}
                    </strong>
                    {" — "}
                    {getName(currentZsm) ||
                      selectedAsm?.zsm_name ||
                      "Unknown ZSM"}
                  </div>

                  <div className="mt-2">
                    <strong>
                      ASM Working Area:
                    </strong>
                    <div>
                      {getAreaText(selectedAsm)}
                    </div>
                  </div>
                </div>

                <h6 className="mb-3">
                  Select Destination ZSM
                </h6>

                <div className="form-group">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search ZSM ID, name or district"
                    value={zsmQuery}
                    onChange={(event) =>
                      setZsmQuery(event.target.value)
                    }
                    disabled={saving}
                  />
                </div>

                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Select</th>
                        <th>ZSM ID</th>
                        <th>Name</th>
                        <th>Working Area</th>
                      </tr>
                    </thead>

                    <tbody>
                      {!loadingZsms &&
                        filteredZsms.map((zsm) => (
                          <tr
                            key={zsm.id}
                            onClick={() =>
                              setChosenZsm(zsm.id)
                            }
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <td>
                              <input
                                type="radio"
                                name="destinationZsm"
                                checked={
                                  chosenZsm === zsm.id
                                }
                                onChange={() =>
                                  setChosenZsm(zsm.id)
                                }
                              />
                            </td>

                            <td>{zsm.id}</td>

                            <td>
                              {getName(zsm) || "—"}
                            </td>

                            <td>
                              {getAreaText(zsm)}
                            </td>
                          </tr>
                        ))}

                      {loadingZsms && (
                        <tr>
                          <td
                            colSpan="4"
                            className="text-center py-4"
                          >
                            Loading eligible ZSMs...
                          </td>
                        </tr>
                      )}

                      {!loadingZsms &&
                        filteredZsms.length === 0 && (
                          <tr>
                            <td
                              colSpan="4"
                              className="text-center py-4 text-muted"
                            >
                              No eligible ZSM found.
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={closeModal}
                  disabled={saving}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={confirmTransfer}
                  disabled={
                    saving ||
                    loadingZsms ||
                    !chosenZsm
                  }
                >
                  {saving
                    ? "Transferring..."
                    : "Confirm Transfer"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

